import React, { useState } from "react";
import Theme from "../../helper/Theme/Theme";
export const ThemeContext = React.createContext(null);
const ThemeContextProvider = (props) => {
    const initialTheme = Theme.initializeTheme();
    const [theme, setTheme] = useState(initialTheme);
    return (React.createElement(ThemeContext.Provider, { value: { theme, setTheme } }, props.children));
};
export default ThemeContextProvider;
